export default __webpack_public_path__ + "static/media/ebook-box-image-04.fe100245.png";